module.exports = __webpack_public_path__ + "img/sect4-5.682a6026.png";